// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Injectable } from '@angular/core';
import { getSystemPicture } from '../../../api/remote-api/.portal.generated/fn/file-storage/get-system-picture';
import { MapApiService } from '../../shared/services/map-api.service';

@Injectable({
  providedIn: 'root',
})
export class ResourceService {
  constructor(private mapApiService: MapApiService) {}

  public productPicure = this.mapApiService.mapEndpoint(getSystemPicture);
}
